import { render } from "./Grant.vue?vue&type=template&id=3e4958e3"
import script from "./Grant.vue?vue&type=script&lang=js"
export * from "./Grant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Special/Grant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e4958e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e4958e3', __exports__)) {
    api.reload('3e4958e3', __exports__)
  }
  
  module.hot.accept("./Grant.vue?vue&type=template&id=3e4958e3", () => {
    api.rerender('3e4958e3', render)
  })

}


export default __exports__